import { createElement as h, useState } from 'react';

/** Preferencia de densidad «Cómoda / Compacta» compartida por las listas del
    portal (Viajes, Unidades, Documentos, Equipo): 'compact' en localStorage
    aplica la clase .dense al contenedor de cada lista — nunca al documento.
    Las reglas viven en density.css (.dense .item / .arow / .table / .subj*).

    Devuelve `dense` para la clase del contenedor y `seg`, el toggle .seg
    listo para la barra de la lista — la misma idea que el `seg` que
    devuelve useMeterInput en Unidades. `pickDensity` queda expuesto por si
    alguna vista necesita fijar la preferencia a mano.

    (Archivo .ts a propósito: el toggle se arma con createElement — son dos
    botones de texto; el set Icon no trae metáfora de densidad, igual que
    las opciones km/mi de useMeterInput.) */
const DENSITY_KEY = 'cargados-density';

export function useDensity() {
  const [dense, setDense] = useState(() => {
    try { return localStorage.getItem(DENSITY_KEY) === 'compact'; } catch { return false; }
  });
  const pickDensity = (compact: boolean) => {
    setDense(compact);
    try {
      if (compact) localStorage.setItem(DENSITY_KEY, 'compact');
      else localStorage.removeItem(DENSITY_KEY);
    } catch { /* sin persistencia */ }
  };
  const seg = h('div', { className: 'seg', role: 'group', 'aria-label': 'Densidad de la lista' },
    h('button', {
      type: 'button', className: `seg-btn${dense ? '' : ' on'}`, 'aria-pressed': !dense,
      onClick: () => pickDensity(false),
    }, 'Cómoda'),
    h('button', {
      type: 'button', className: `seg-btn${dense ? ' on' : ''}`, 'aria-pressed': dense,
      onClick: () => pickDensity(true),
    }, 'Compacta'));
  return { dense, pickDensity, seg };
}
